import { 
  // subPlanDescription, 
  // getRootFloorPlanNames, 
  getRootMinRent, 
  getRootMaxRent } from './entrata-data.js';
// import {getFpRootName} from './helpers.js';
// import { firstTwoLetters, noDec } from './helpers.js';
const $ = jQuery;

// const unitMatchesFpId = fpId => unit => unit.floorPlanId === fpId;

// const makeUnitItem = function(unit) {
//   const $unitNumber = $('<h5>').addClass('unit-name').text(unit.unitNumber);
//   const $unitDetailsList = $('<ul>').addClass('unit-details');
//   const $unitRentRange = $('<p>').html(`$${noDec(unit.minRent)}&ndash;$${noDec(unit.maxRent)}`);
//   const $availableDate = $('<p>').html(unit.availableDate);
//   $unitDetailsList.append(
//     $('<li>').append(
//       $('<h6>').addClass('unit-detail-title').text('Rent Range'),
//       $unitRentRange
//     ),
//     $('<li>').append(
//       $('<h6>').addClass('unit-detail-title').text('Availability'),
//       $availableDate
//     )
//   );
//   const $unitItem = $('<li>').addClass('unit').append(
//     $unitNumber,
//     $unitDetailsList
//   );
//   return $unitItem;
// };

// const makeUnitsList = function(units,floorPlanName) {
//   const unitItems = units.map(makeUnitItem);
//   return $('<ul>').addClass('units-list clean-list-all stack-1').attr('id', `${floorPlanName}-units-list`).append(unitItems);
// };

// const getDrawerObjectFromUnits = allUnits => floorPlan => {
//   const rootFpName = floorPlan.floorPlanName.slice(0,2);
//   const matchingUnits = allUnits.filter(unitMatchesFpId(floorPlan.floorPlanId));
//   const $unitsList = makeUnitsList(matchingUnits, floorPlan.floorPlanName);
//   const $fpButton = $('<h4>').append(
//     $('<button>').addClass('sub-plan-button')
//         .attr('aria-expanded', 'false')
//         .attr('aria-controls', `${floorPlan.floorPlanName}-units-list`)
//         .attr('data-min-rent', floorPlan.minRent)
//         .attr('data-fp-root', firstTwoLetters(floorPlan.floorPlanName))
//         .text(subPlanDescription(floorPlan.floorPlanName))
//   )
//   return { 'button': $fpButton, 'list': $unitsList, 'rootFpName': rootFpName };
// };

// const getRootFpSectionFromDrawerObjects = allDrawerObjects => rootFpName => {
//   const matchingDrawerObjects = allDrawerObjects.filter(drawerObject => drawerObject.rootFpName.toLowerCase() === rootFpName.toLowerCase());
//   const $section = $('<section>').addClass('sub-plan-buttons-section').attr('data-fp-root',rootFpName);
//   $section.append(
//     $('<header>').append($('<h3>').text('View Availability'))
//   );
//   matchingDrawerObjects.forEach(drawerObject => {
//     $section.append(drawerObject.button, drawerObject.list);
//   });
//   return  $section;
// };

// export const makeUnifiedUnitsSections = function(allAvailableUnits, availableFloorPlans) {
//   const drawerObjectMaker = getDrawerObjectFromUnits(allAvailableUnits);
//   const fpAvailabilityDrawerObjects = availableFloorPlans.map(drawerObjectMaker);
//   const availableRootFloorPlanNames = getRootFloorPlanNames(availableFloorPlans); 
//   const rootFpSectionMaker = getRootFpSectionFromDrawerObjects(fpAvailabilityDrawerObjects);
//   // TODO make a section fragment for each avialable floor plan root and insert the button+list fragments whose floor plan matches that root
//   const drawerSections = availableRootFloorPlanNames.map(rootFpSectionMaker);
//   return drawerSections;
// };

// export const updateUnitSections = function($fpCards, units, floorPlans) {
//   const unitSections = makeUnifiedUnitsSections(units,floorPlans);
//   $fpCards.each((index,el) => {
//     let newAvailabilityHTML = "";
//     const $fpCard = $(el);
//     const fpName = $fpCard.data('fp-name');
//     const $fpAvailabilitySection = unitSections.find(section => section.data('fp-root') === fpName);
//     if ($fpAvailabilitySection) {
//       newAvailabilityHTML = $fpAvailabilitySection.html();
//     }
//     $fpCard.find('.sub-plan-buttons-section').html(newAvailabilityHTML);
//   });
// }; 

export const initFpCards = function($fpCardList, entrataData) {
  // build all the availability sections as fragments to be attached to floor plan cards
  // const $availabilitySections = makeUnifiedUnitsSections(entrataData.available_units, entrataData.available_floor_plans);
  $fpCardList.each((index, el) => {
    const $fpCard = $(el);
    const fpName = $fpCard.data('fp-name');
    const startingRate = getRootMinRent(fpName, entrataData.available_floor_plans).toLocaleString();
    const maxRate = getRootMaxRent(fpName, entrataData.available_floor_plans).toLocaleString();
    // const $fpAvailabilitySection = $availabilitySections.find(section => section.data('fp-root') === fpName);
    $fpCard.attr('data-min-rent', startingRate);
    $fpCard.attr('data-max-rent', maxRate);
    if (startingRate && startingRate !== '0') {
      $fpCard.find('.starting-rate').text(`From $${startingRate}–$${maxRate}`).css('display','block');
    } else {
      $fpCard.find('.starting-rate').text('Contact Us For Rates').css('display','block');
    }
    // $fpCard.find('.wrapper').append($fpAvailabilitySection);
  });
};

// const toggleDrawer = function($list) {
//   let listHeightChange = 0;
//   const isOpening = !$list.hasClass('open');
//   if (isOpening) {
//     $list.siblings('.units-list').removeClass('open').css('max-height', 0);
//     listHeightChange = $list.prop('scrollHeight');
//   }
//   $list.toggleClass('open').css('max-height', listHeightChange);
//   return $list;
// };

// export const drawerToggleButtonControl = function(event) {
//   const $target = $(event.target);
//   const $delegate = $(event.delegateTarget);
//   const unitListId = $target.attr('aria-controls');
//   const $unitList = $delegate.find(`#${unitListId}`);
//   $target.parent().siblings().find('button').attr('aria-expanded', 'false');
//   if ($target.attr('aria-expanded') === 'true') {
//     $target.attr('aria-expanded', 'false');
//   } else {
//     $target.attr('aria-expanded', 'true');
//   }   
//   toggleDrawer($unitList);
// };